export const scrollToJustAbove_manual = (
  element: Element,
  margin: number = 20
) => {
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect + window.pageYOffset;
  const offsetPosition = elementPosition - margin;

  window.scrollTo({ top: offsetPosition, behavior: "smooth" });
};

export const scrollToJustAbove = (element: Element) => {
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  scrollToJustAbove_manual(element, isMobile ? 170 : 145);
};
